export default {"src":"/_next/static/media/burger.8cede5cf.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};